import React, { useEffect, useState } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { VIP_LEVELS } from "../../constant/vip";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";

const SetupScore = () => {
  const [configGame, setConfigGame] = useState();
  const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
  const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

  const [vipKeys] = useState(VIP_LEVELS);
  const [vipMinScore, setVipMinScore] = useState({});
  const [vipMaxScore, setVipMaxScore] = useState({});
  const [vipHitRatePct, setVipHitRatePct] = useState({}); // UI hiển thị %
  const [multiple, setMultiple] = useState(1);

  const [top1, setTop1] = useState();
  const [top2, setTop2] = useState();
  const [top3, setTop3] = useState();
  const [top4, setTop4] = useState();
  const [top5, setTop5] = useState();
  const [top6, setTop6] = useState();
  const [top7, setTop7] = useState();
  const [top8, setTop8] = useState();
  const [top9, setTop9] = useState();
  const [top10, setTop10] = useState();

  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    getDataConfig();
  }, []);


  const validPositiveNumber = (v) => {
    const n = Number(v);
    return Number.isFinite(n) && n > 0;
  };

  const getDataConfig = async () => {
    try {
      const res = await API.get(`${CONFIG}`);
      const data = res?.data?.data ?? {};
      const vipLevels = data.vipLevels ?? {};

      const nextMin = {},
        nextMax = {},
        nextHitPct = {};

      VIP_LEVELS.forEach((k) => {
        const lvl = vipLevels[k] ?? {};
        nextMin[k] = Number(lvl.MIN_SCORE ?? 0);
        nextMax[k] = Number(lvl.MAX_SCORE ?? 0);
        nextHitPct[k] = Number((lvl.GHOST_RATE ?? 0) * 100);
      });

      setVipMinScore(nextMin);
      setVipMaxScore(nextMax);
      setVipHitRatePct(nextHitPct);

      setMultiple(Number(data?.multiple ?? 1));

      setTop1(data?.eventRewards?.TOP1);
      setTop2(data?.eventRewards?.TOP2);
      setTop3(data?.eventRewards?.TOP3);
      setTop4(data?.eventRewards?.TOP4);
      setTop5(data?.eventRewards?.TOP5);
      setTop6(data?.eventRewards?.TOP6);
      setTop7(data?.eventRewards?.TOP7);
      setTop8(data?.eventRewards?.TOP8);
      setTop9(data?.eventRewards?.TOP9);
      setTop10(data?.eventRewards?.TOP10);

      setConfigGame({ ...data });
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdateConfig = async () => {
    try {
      setIsShowModalConfirm(false);

      for (const k of vipKeys) {
        const min = vipMinScore[k];
        const max = vipMaxScore[k];
        const hit = vipHitRatePct[k];

        if (max < min) {
          showError(`MAX_SCORE của ${k} phải ≥ MIN_SCORE`);
          return;
        }
        if (hit < 0 || hit > 100) {
          showError(`Tỉ lệ trúng (GHOST_RATE) của ${k} phải trong 0 - 100`);
          return;
        }
      }

      if (
        !validPositiveNumber(top1) ||
        !validPositiveNumber(top2) ||
        !validPositiveNumber(top3) ||
        !validPositiveNumber(top4) ||
        !validPositiveNumber(top5) ||
        !validPositiveNumber(top6) ||
        !validPositiveNumber(top7) ||
        !validPositiveNumber(top8) ||
        !validPositiveNumber(top9) ||
        !validPositiveNumber(top10)
      ) {
        showError("Bảng xếp hạng phải là số dương (>0).");
        return;
      }

      if (!validPositiveNumber(multiple)) {
        showError("Vòng cược trước khi rút phải là số dương (>0).");
        return;
      }

      // Khi lưu: chia cho 100
      const vipLevelsBody = {};

      vipKeys.forEach((k) => {
        vipLevelsBody[k] = {
          ...(configGame?.vipLevels?.[k] ?? {}),
          MIN_SCORE: Number(vipMinScore[k] ?? 0),
          MAX_SCORE: Number(vipMaxScore[k] ?? 0),
          GHOST_RATE: Number((vipHitRatePct[k] ?? 0) / 100),
        };
      });

      const body = {
        config: {
          vipLevels: vipLevelsBody,
          eventRewards: {
            TOP1: Number(top1),
            TOP2: Number(top2),
            TOP3: Number(top3),
            TOP4: Number(top4),
            TOP5: Number(top5),
            TOP6: Number(top6),
            TOP7: Number(top7),
            TOP8: Number(top8),
            TOP9: Number(top9),
            TOP10: Number(top10),
          },
          multiple: Number(multiple ?? 1),
        },
      };

      await API.patch(`${UPDATE_CONFIG}`, body);
      setIsShowModalSuccess(true);
    } catch (err) {
      console.log(err);
    }
  };

  const showError = (msg) => messageApi.open({ type: "error", content: msg });
  const handleShowModal = () => setIsShowModalConfirm(true);

  return (
    <div className="col-12" style={{ background: "#f7f9fa", minHeight: "100vh", padding: 24 }}>
      {contextHolder}
      <div style={{ fontWeight: 600, fontSize: 18, marginBottom: 16 }}>Cài đặt điểm nhận</div>

      <div style={{ background: "#fff", borderRadius: 8, padding: 24, boxShadow: "0 2px 8px #eee", marginBottom: 32 }}>
        <div style={{ fontWeight: 500, fontSize: 16, marginBottom: 12 }}>Cấp VIP và tỉ lệ trả thưởng</div>
        <div style={{ display: "flex", gap: 24, marginBottom: 24 }}>
          <div style={{ width: "100%" }}>
            <div style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", marginBottom: 8 }}>
              <div></div>
              <div style={{ textAlign: "center", fontWeight: 400 }}>Điểm nhận cao nhất trong 1 lượt</div>
              <div style={{ textAlign: "center", fontWeight: 400 }}>Tỉ lệ % xuất hiện vật phẩm</div>
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
              {vipKeys.map((k) => (
                <div
                  key={k}
                  style={{ display: "grid", gridTemplateColumns: "160px 1fr 1fr", gap: "12px", alignItems: "center" }}
                >
                  <span style={{ textAlign: "right" }}>{k}:</span>
                  <InputNumber
                    style={{ width: "100%" }}
                    value={vipMaxScore[k]}
                    onChange={(v) => setVipMaxScore((p) => ({ ...p, [k]: Number(v ?? 0) }))}
                    min={0}
                  />
                  <InputNumber
                    style={{ width: "100%" }}
                    value={vipHitRatePct[k]}
                    onChange={(v) => setVipHitRatePct((p) => ({ ...p, [k]: Number(v ?? 0) }))}
                    min={0}
                    max={100}
                    step={0.01}
                    precision={2}
                  />
                </div>
              ))}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "160px 1fr",
                gap: "12px",
                alignItems: "center",
                marginTop: 16,
              }}
            >
              <span style={{ textAlign: "right" }}>Vòng cược trước khi rút:</span>
              <InputNumber
                style={{ width: "100%" }}
                value={multiple}
                onChange={(v) => setMultiple(Number(v ?? 1))}
                min={1}
                max={999}
              />
            </div>
          </div>
        </div>

        <div style={{ fontWeight: 500, fontSize: 16, marginBottom: 12 }}>Bảng xếp hạng</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 24 }}>
          {[{ v: top1, set: setTop1, l: "Top 1" },
            { v: top2, set: setTop2, l: "Top 2" },
            { v: top3, set: setTop3, l: "Top 3" },
            { v: top4, set: setTop4, l: "Top 4" },
            { v: top5, set: setTop5, l: "Top 5" },
            { v: top6, set: setTop6, l: "Top 6" },
            { v: top7, set: setTop7, l: "Top 7" },
            { v: top8, set: setTop8, l: "Top 8" },
            { v: top9, set: setTop9, l: "Top 9" },
            { v: top10, set: setTop10, l: "Top 10" }].map((o, i) => (
            <div key={i} className="flex w-full items-center">
              <div className="flex w-[20%] justify-end mr-10">{o.l}:</div>
              <div className="w-[60%]">
                <InputNumber style={{ width: "100%" }} value={o.v} onChange={o.set} min={1} />
              </div>
            </div>
          ))}
        </div>

        <div style={{ textAlign: "center", marginTop: 24 }}>
          <Button type="primary" size="large" style={{ minWidth: 120 }} onClick={handleShowModal}>
            Cập nhật
          </Button>
        </div>
      </div>

      {isShowModalConfirm && (
        <ModalCommon
          isShow={isShowModalConfirm}
          message={TEXT_DEF.text0062}
          txtBtnAcc={TEXT_DEF.text0008}
          textBtnClose={TEXT_DEF.text0023}
          actionNext={handleUpdateConfig}
          close={() => setIsShowModalConfirm(false)}
        />
      )}

      {isShowModalSuccess && (
        <ModalCommon
          isShow={isShowModalSuccess}
          message={TEXT_DEF.text0063}
          txtBtnAcc={TEXT_DEF.text0007}
          actionNext={() => setIsShowModalSuccess(false)}
          close={() => setIsShowModalSuccess(false)}
        />
      )}
    </div>
  );
};

export default SetupScore;
